import React from 'react'
import IOSManagementCard from '../ios-management-card'
import AppleButton from './apple-button'
import AndroidButton from './android-button'
import Center from '../../common/center'

const MobileScreen = () => {

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly'

                }}
            >
                <AppleButton />
                <AndroidButton />
            </div>
            <Center>
                <IOSManagementCard />
            </Center>
        </div>
    )
}

export default MobileScreen
